var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Configuración Alarmas")])], 1),
      _c("v-divider"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.tipoAlarma.label,
                      items: _vm.tipos,
                      "item-text": "configdescripcion",
                      "item-value": "configid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.tipoAlarma.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.tipoAlarma, "value", $$v)
                      },
                      expression: "formFields.tipoAlarma.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.ubicacion.label,
                      items: _vm.ubicaciones,
                      "item-text": "tipoubicaname",
                      "item-value": "tipoubicaid",
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.ubicacion.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.ubicacion, "value", $$v)
                      },
                      expression: "formFields.ubicacion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs2: "", sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.estado.label,
                      items: _vm.estados,
                      clearable: ""
                    },
                    model: {
                      value: _vm.formFields.estado.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.estado, "value", $$v)
                      },
                      expression: "formFields.estado.value"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs2: "", sm2: "", md2: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center botones-filtros mt-1" },
                  [
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.filtrar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("search")
                        ]),
                        _vm._v("Filtrar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        on: {
                          click: function($event) {
                            return _vm.clearFilters()
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("clear")
                        ]),
                        _vm._v("Limpiar")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs4: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Buscar", clearable: "", outlined: "" },
                on: {
                  keyup: function($event) {
                    return _vm.gridApi.setQuickFilter(_vm.filtro)
                  },
                  "click:clear": function($event) {
                    return _vm.gridApi.setQuickFilter("")
                  }
                },
                model: {
                  value: _vm.filtro,
                  callback: function($$v) {
                    _vm.filtro = $$v
                  },
                  expression: "filtro"
                }
              })
            ],
            1
          ),
          _c("v-flex", {
            attrs: { xs12: "", sm6: "", md6: _vm.accionCrear.visible }
          }),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.exportarExcel }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  ),
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticStyle: { "padding-right": "20px" },
                          attrs: { color: "#ffe800" },
                          on: {
                            click: function($event) {
                              _vm.showModalNew = true
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Crear")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card ConfiguracionAlarmas" },
        [
          _c("MantenedorGrid", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap' sans-serif"
            },
            attrs: {
              gridOptions: _vm.gridOptions,
              funcionalidadId: _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.showModalNew
        ? _c("CrearAlarma", {
            attrs: { ubicaciones: _vm.ubicaciones, tiposAlarma: _vm.tipos },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e(),
      _vm.showModalEdit
        ? _c("EditarAlarma", {
            attrs: {
              ubicaciones: _vm.ubicaciones,
              tiposAlarma: _vm.tipos,
              itemSelected: _vm.editedItem
            },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e(),
      _vm.verHistorial
        ? _c("ModalVerHistorico", {
            attrs: { alarmaid: _vm.editedItem, alarmaNombre: _vm.alarmaNombre },
            on: {
              modalAsociacionEmit: function($event) {
                return _vm.moduloModalCallback($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }